import {
  Button,
  Divider,
  Drawer,
  Input,
  Select,
  Table,
  Typography,
} from "antd";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { ExportOutlined, PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import _ from "lodash";
import * as XLSX from "xlsx";

const MerchantReportPerProduct = ({ open, close, data, dateFrom, dateTo }) => {
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  // const [filteredData, setFilteredData] = useState({ data: [], ready: false });
  const [searchProd, setSearchProd] = useState("");
  const [searchCat, setSearchCat] = useState("all");
  var perprod = null;
  // const [searchable, setSearchable] = useState(data.data.filter((data) => data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0);

  // const [searchable, setSearchable] = useState(() =>
  //   data.data.filter((item) =>
  //     item.product.toLowerCase().includes(search.toLowerCase())
  //   )
  // );
  // console.log("data: ", data);
  //   console.log("dateTo: ", dateTo);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
    },
  });

  const searchableProduct = data.data.filter((data) => {
    return data.product.toLowerCase().indexOf(searchProd.toLowerCase()) >= 0;
  });

  const searchableCategory = searchableProduct.filter((data) => {
    if (searchCat !== "all") {
      return data.product_category
        ?.toLowerCase()
        .includes(searchCat.toLowerCase());
    } else {
      return data;
    }
  });

  const searchableCategory2 = searchableProduct.filter((data) => {
    return data.product_category === null;
  });

  perprod = _.chain(
    searchCat === "Additional Services"
      ? searchableCategory2
      : searchableCategory
  )
    .groupBy((g) => g.order_category)
    .map((value, key) => ({
      order_category: key,
      data:
        value[0].order_category !== "additional-service"
          ? _.chain(value)
              .groupBy((h) => h.product_category)
              .map((value2, key) => ({
                product_category: key,
                data: value2,
              }))
              .value()
          : value,
    }))
    .value();

  const exportToExcel = () => {
    const selectedColumns = ["product", "total"]; // Add columns you want to export
    const filteredData =
      searchCat === "Additional Services"
        ? searchableCategory2.map((row) => {
            const filteredRow = {};
            selectedColumns.forEach((column) => {
              filteredRow[column] = row[column];
            });
            return filteredRow;
          })
        : searchableCategory.map((row) => {
            const filteredRow = {};
            selectedColumns.forEach((column) => {
              filteredRow[column] = row[column];
            });
            return filteredRow;
          });
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "digimenu_product_sold.xlsx");
  };

  return (
    <Drawer
      title="Product Sold"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ marginRight: 13, fontWeight: "bold" }}>
              Search Product:{" "}
            </Typography>
            <Input
              id="search-product"
              placeholder="Type here..."
              value={searchProd}
              onChange={(e) => setSearchProd(e.target.value)}
              style={{
                // border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 250,
              }}
              // size="large"
            />
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ marginRight: 10, fontWeight: "bold" }}>
              Select Category:{" "}
            </Typography>
            <Select
              id="category-dropdown"
              placeholder="Select category"
              onChange={(e) => setSearchCat(e)}
              style={{
                // border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 250,
              }}
              value={searchCat}
            >
              <Select.Option value="all">All</Select.Option>
              <Select.Option value="Additional Services">
                Additional Services
              </Select.Option>

              {data.data.filter((data) => data.product_category !== null)
                .length > 0 ? (
                data.data
                  .filter((data) => data.product_category !== null)
                  .map((data, index) => (
                    <Select.Option value={data.product_category} key={index}>
                      {data.product_category}
                    </Select.Option>
                  ))
              ) : (
                <Select.Option value="">No category found!</Select.Option>
              )}
            </Select>
          </div>
          {/* <Input
            id="search-category"
            placeholder="Search category"
            value={searchCat}
            onChange={(e) => setSearchCat(e.target.value)}
            style={{
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
          /> */}
        </div>
      </div>
      <Divider />
      {perprod !== null && perprod.length > 0 && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint, marginTop: 10 }}
            ref={componentRef}
          >
            <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
              Date From: {moment(dateFrom).format("LLL")}
            </Typography>
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: 14,
                marginBottom: 10,
              }}
            >
              Date To: {moment(dateTo).format("LLL")}
            </Typography>
            <Divider />

            <table
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {perprod.length > 0 &&
                perprod.map((item, index) => {
                  if (item.order_category === "products") {
                    return (
                      <Fragment key={index}>
                        <thead>
                          <tr>
                            <td colSpan={3} style={{ fontWeight: "bold" }}>
                              Product Goods
                            </td>
                          </tr>
                        </thead>
                        <thead style={{ border: "1px solid #e5e5e5" }}>
                          <tr style={{ display: "flex" }}>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              Product
                            </td>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              Quantity
                            </td>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              Unit
                            </td>
                          </tr>
                        </thead>
                        {item.data.length > 0 &&
                          item.data.map((item2, index2) => (
                            <Fragment key={index2}>
                              <thead>
                                <tr style={{ display: "flex" }}>
                                  <td
                                    colSpan={3}
                                    style={{
                                      marginLeft: 10,
                                    }}
                                  >
                                    &bull; {item2.product_category}
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {item2.data.length > 0 &&
                                  item2.data.map((item3, index3) => (
                                    <tr
                                      style={{ display: "flex" }}
                                      key={index3}
                                    >
                                      <td
                                        style={{
                                          display: "flex",
                                          width: "100%",
                                          border: "1px solid #e5e5e5",
                                        }}
                                      >
                                        {item3.product}
                                      </td>
                                      <td
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          width: "100%",
                                          border: "1px solid #e5e5e5",
                                        }}
                                      >
                                        {item3.total}
                                      </td>
                                      <td
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          width: "100%",
                                          border: "1px solid #e5e5e5",
                                        }}
                                      >
                                        {item3.per_piece ? "PC(S)" : "GRAM(S)"}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </Fragment>
                          ))}
                      </Fragment>
                    );
                  } else {
                    return (
                      <Fragment key={index}>
                        <thead>
                          <tr>
                            <td colSpan={3} style={{ fontWeight: "bold" }}>
                              Services
                            </td>
                          </tr>
                        </thead>
                        <thead style={{ border: "1px solid #e5e5e5" }}>
                          <tr style={{ display: "flex" }}>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              Service
                            </td>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                              }}
                            >
                              Transaction Count
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {item.data.map((item2, index2) => (
                            <tr style={{ display: "flex" }} key={index2}>
                              <td
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  border: "1px solid #e5e5e5",
                                }}
                              >
                                {item2.product}
                              </td>
                              <td
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "100%",
                                  border: "1px solid #e5e5e5",
                                }}
                              >
                                {item2.total}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Fragment>
                    );
                  }
                })}
            </table>

            {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                marginBottom: 10,
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  fontWeight: "bold",
                }}
              >
                PRODUCT
              </div>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  justifyContent: "end",
                  fontWeight: "bold",
                }}
              >
                QTY
              </div>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  justifyContent: "end",
                  fontWeight: "bold",
                }}
              >
                UNIT
              </div>
            </div> */}

            {/* <Divider /> */}

            {/* {data.data.length > 0 &&
              data.data.map((data, index) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    marginBottom: 10,
                    width: "100%",
                  }}
                  key={index}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "calc(100% / 3)",
                    }}
                  >
                    <Typography style={{ fontWeight: "bold" }}>
                      {data.product}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "calc(100% / 3)",
                      justifyContent: "end",
                    }}
                  >
                    {data.total}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "calc(100% / 3)",
                      justifyContent: "end",
                    }}
                  >
                    {data.per_piece ? "PC(S)" : "GRAM(S)"}
                  </div>
                </div>
              ))} */}
          </div>
          <div style={{ display: "flex", marginTop: 10 }}>
            <div style={{ flexGrow: 1 }} />
            <div>
              <Button
                type="primary"
                onClick={handlePrint}
                icon={<PrinterOutlined />}
                style={{ marginRight: 6 }}
              >
                Print
              </Button>

              <Button icon={<ExportOutlined />} onClick={exportToExcel}>
                Export
              </Button>
            </div>
          </div>
        </>
      )}
    </Drawer>
  );
};

export default MerchantReportPerProduct;
